export default __webpack_public_path__ + "static/media/p4.b037af20.png";